<div class="wrapper">
    <div class="icon">
        <app-icon type="Exclamation"></app-icon>
    </div>
    <div class="text">{{ errorMessage }}</div>
</div>
